import { useMutation } from "react-query";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { httpService } from "utils";

import { ILoginForm } from "../application/types/ILoginForm";

export const useRegisterUser = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  return useMutation((data: FormData) => {
    return registerUser(data, friendlyUrl);
  });
};

const registerUser = (formData: FormData, friendlyUrl: string) => {
  return httpService().post<ILoginForm>(
    `/e-reservation/${friendlyUrl}/register`,
    formData
  );
};
